import SearchSwitchViewButtons from './search-switch-view-buttons';

export default SearchSwitchViewButtons;
